module.exports = __webpack_public_path__ + "static/media/PageNotFound.1ef634fb.png";